module.exports = __webpack_public_path__ + "static/media/powered-by-studyo.a21a74cc.png";